import { ElementDetails } from "@/lib/types";
import { FieldImage } from "../ElementSettings/FieldImage";

export const details = {
  name: "Root",
  description: "Root element",
  category: "not-listed",
  shouldBeListed: false,
  grid: {},
  defaultProps: {
    backgroundImage: {
      provider: "unsplash",
      type: "random",
    },
  },
  fields: [
    {
      title: "Background Image",
      prop: "backgroundImage",
      type: "custom",
      config: {
        render: FieldImage,
      },
    },
  ],
} as ElementDetails;
